var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 2H3C2.44772 2 2 2.44772 2 3V21C2 21.5523 2.44772 22 3 22H25C25.5523 22 26 21.5523 26 21V3C26 2.44772 25.5523 2 25 2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.0001L8.29288 10.7072C8.38573 10.6143 8.49597 10.5407 8.6173 10.4904C8.73862 10.4402 8.86866 10.4143 8.99998 10.4143C9.1313 10.4143 9.26134 10.4402 9.38267 10.4904C9.50399 10.5407 9.61423 10.6143 9.70709 10.7072L15.2929 16.293C15.3857 16.3858 15.496 16.4595 15.6173 16.5098C15.7386 16.56 15.8687 16.5859 16 16.5859C16.1313 16.5859 16.2613 16.56 16.3827 16.5098C16.504 16.4595 16.6142 16.3858 16.7071 16.293L19.2929 13.7072C19.3857 13.6143 19.496 13.5407 19.6173 13.4904C19.7386 13.4402 19.8687 13.4143 20 13.4143C20.1313 13.4143 20.2613 13.4402 20.3827 13.4904C20.504 13.5407 20.6142 13.6143 20.7071 13.7072L26 19.0001",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C18.3284 10 19 9.32843 19 8.5C19 7.67157 18.3284 7 17.5 7C16.6716 7 16 7.67157 16 8.5C16 9.32843 16.6716 10 17.5 10Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.de1feb2c305659727cb5ae40f8fff835.svg";
export { ForwardRef as ReactComponent };